/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import { Link, useNavigate } from "react-router-dom";
import { NumericFormat } from 'react-number-format';
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { dateFormatWithLocale } from '../../../../../helpers/general';

/* Components */
import UCGrid from "../../../../ucgrid";
import ReportsNoBookings from "../../../../reportsNoBookings";
import { useLocaleContext } from '../../../../../contexts/localeContext';

/* Styles */
import styles from "./styles.js"


const HotelBookingGrid = (props) => {
  const {gridOptions, setGridOptions, bookingsResponse, onRowClick} = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const navigate = useNavigate();
  const locale = useLocaleContext();

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <div className={classes.bookingsGrid}>
      <UCGrid
        gridName="hotelBookingsGrid"
        data={ bookingsResponse?.results }
        columns={ bookingsResponse?.columns }
        actions={ bookingsResponse?.actions }
        handlePageChange={(page) => {setGridOptions({
          ...gridOptions,
          page
        });
        page > 1 ? navigate(`/app/reports/hotel-bookings?page=${page}`) : navigate(`/app/reports/hotel-bookings`)
        }}
        setSelectedRow={setSelectedRow}
        spinner="hotelBookingsGridSpinner"
        customColumns={{
          bookingDate: (row) => (
            dateFormatWithLocale(row.bookingDate, locale)
          ),
          checkInDate: (row) => (
            dateFormatWithLocale(row.checkInDate, locale)
          ),
          checkOutDate: (row) => (
            dateFormatWithLocale(row.checkOutDate, locale)
          ),
        }}
        columnCustomWidth={{
          reservationStatus: "200px !important",
          rateType: "250px !important",
          confirmationNumber: "200px !important",
          numberOfRooms: "200px !important",
          teamName: "200px !important",
        }}
        noDataComponent={ <ReportsNoBookings/> }
        showHeader={true}
        persistTableHead={false}
        onRowClick={onRowClick}    
      />
    </div>
  )
}

export default HotelBookingGrid;
